import React from "react"
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import Button from "./Button"
import classes from "./ConfirmationModal.module.scss"

const ConfirmationModal = props => {
  const {
    show,
    title,
    subtitle,
    onHide,
    onExited,
    onConfirm,
    sending
  } = props

  const [t] = useTranslation()

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      onExited={onExited}
      centered
    >
      <div className={classes["container"]}>
        <h4 className={classes["title"]}>
          {title}
        </h4>
        {
          subtitle &&
          <h6 className={classes["subtitle"]}>
            {subtitle}
          </h6>
        }
        <div className={classes["footer"]}>
          <Button
            color="danger"
            disabled={sending}
            className={classes["yes"]}
            onClick={onHide}
          >
            {t("خیر")}
          </Button>
          <Button
            color="success"
            loading={sending}
            onClick={onConfirm}
          >
            {t("بله")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationModal